import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { StyledLinearProgress } from './styled';

interface Props {
    value: number;
}

const TranslationProgress = (props: Props) => {
    const { value } = props;

    return (
        <Box display='flex' alignItems='center'>
            <Box width='100%' mr={1}>
                <StyledLinearProgress variant='determinate' value={value} />
            </Box>
            <Box minWidth={35}>
                <Typography variant='body2' color='textSecondary'>{Math.round(props.value)}%</Typography>
            </Box>
        </Box>
    );
};

export default TranslationProgress;
